export { CLIENT_ROUTES, CLIENT_ROUTE_KEYS } from "./client-routes/client.routes"
export { default as KNOWLEDGE_MANAGEMENT_ROUTES, KMT_PATH_KEYS } from "./employee-routes/knowledgeManagementAssociate.routes"

export const EMPLOYEE_LOGIN = "/employee_login"


export const HOME_ROUTE = "/"

export const CONNECT_TO_OUTLOOK = "/connect_to_outlook"

export const VIEW_TRAINING_SHEET_QUERY_KEY = 'view_training_sheet'

// when client clicks on the Our Process btn in sidebar
export const CIP_LINK = "https://cip.jaspercolin.com"

export const CONNECT_POA_URL = "/selectFile"